import { useState } from "react";
import { Student } from "../providers/studentsProvider";
import { capitalize } from "../utils/string";

type Action = "cancelDunning" | "bookOutDunning";

type UseDunningActionDialogReturn<T extends Action> = {
  open: boolean;
  onClose: () => void;
} & { [K in `${T}Student`]: Student | null } & { [K in `${T}Meta`]: Record<string, unknown> } & {
  [K in `open${Capitalize<T>}Dialog`]: (student: Student) => void;
} & { [K in `set${Capitalize<T>}DialogMeta`]: (meta: Record<string, unknown>) => void };

export function useDunningActionDialog<T extends Action>(action: T): UseDunningActionDialogReturn<T> {
  const [open, setOpen] = useState<boolean>(false);
  const [student, setStudent] = useState<Student | null>(null);
  const [meta, setMeta] = useState<Record<string, unknown>>({});

  const openDialog = (student: Student) => {
    setStudent(student);
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setStudent(null);
  };

  const result = {
    open,
    onClose,
    [`${action}Student`]: student,
    [`${action}Meta`]: meta,
    [`open${capitalize(action)}Dialog`]: openDialog,
    [`set${capitalize(action)}DialogMeta`]: setMeta,
  } as UseDunningActionDialogReturn<T>;
  return result;
}
